import { Text } from '@/components/shared/components/Text';

export const businessNameFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.55,
    field: 'business_name',
    headerName: <Text tId={'BUSINESS_NAME'} />,
    renderCell: (rowData) => (
      <div style={{ minWidth: '100px', display: 'flex', alignItems: 'center' }}>
        <div
          className={'line-clamp-3'}
          style={{
            minWidth: '120px',
            lineHeight: '1.43',
          }}
        >
          {rowData.row.registrationFields.businessName}
        </div>
      </div>
    ),
  };
};
